/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const UserName = styled.div`
  font-size: 0.7rem;
  font-weight: bold;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid ${theme.color.border.border01};
  max-width: 100%;
  word-wrap: break-word;
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-items: center;
`;
